<template>
	<div>
		<notifications position="top center" group="info" />

		<h1 v-if="!minimal">{{_title || "Bibliothèque"}}</h1>

		<b-form inline :class="{ 'library-locked-by-test': codegenFocusMode }">
			<b-input-group style="width:300px" v-if="!_type" prepend="Type">
				<b-form-select v-model="type" :options="types"></b-form-select>
			</b-input-group>
			<b-input-group style="width:300px" prepend="Nom">
				<b-form-input v-model="name"></b-form-input>
			</b-input-group>
			<b-input-group style="width:200px" prepend="Version">
				<b-form-input v-model="version"></b-form-input>
			</b-input-group>
			<b-button v-b-modal="'modal' + id">Charger</b-button>
			<b-button v-if="!minimal" @click="save_db" :disabled="!version || !name"><i class="fas fa-save"></i></b-button>
			<b-button v-if="!minimal" v-b-modal="'modal_file' + id">Fichier</b-button>
			<b-button v-if="!minimal" v-b-modal="'modal_rename' + id">Renommer</b-button>
			<b-button v-if="!minimal" @click="archive_confirm" :disabled="!name"><i class="fas fa-archive"></i></b-button>
			<b-button @click="new_elem"><i class="fas fa-plus"></i></b-button>
		</b-form>

		<b-modal :hide-footer="true" :id="'modal_file' + id" title="Fichier">
			<b-file
				accept=".json"
				@change="load_file"
				placeholder="charger (fichier)"></b-file>
			<br /><br />
			<b-button @click="save">sauvergarder (fichier)</b-button>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal_rename' + id" title="Renommer">
			<p>Nouveau nom</p>
			<b-input v-model="new_name"></b-input>
			<br />
			<b-button @click="rename">Rennomer</b-button>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
			<span v-if="!_type" >Type</span>
			<b-select v-if="!_type" v-model="type" :options="types"></b-select>
			<span>Nom</span>
			<v-select v-model="load_name" :options="names"></v-select>
			<span>Version</span>
			<v-select
				v-model="load_version"
				:options="versions"></v-select>
		</b-modal>

		<br />

		<div v-if="type == 'document_zone'">
			<document_extraction_zones
				ref="element"
				start_name="type"
				:library="true"></document_extraction_zones>
		</div>
		<div v-if="type == 'db'">
			<database_requests
				ref="element"
				:library="true"
				:minimal="minimal"></database_requests>
		</div>
		<div v-if="type == 'validation'">
			<validation_builder ref="element"></validation_builder>
		</div>
		<div v-if="type == 'dashboard'">
			<dashboard_builder ref="element" @codegen-test-mode="onCodegenTestMode"></dashboard_builder>
		</div>
		<div v-if="type == 'docx'">
			<docx :library="true" ref="element"></docx>
		</div>
		<div v-if="type == 'rules'">
			<rules_editor :library="true" ref="element" :prev_data="prev_data" :hide_treatment="hide_treatment"></rules_editor>
		</div>
		<div v-if="type == 'chatgpt'">
			<chatgpt :library="true" ref="element"></chatgpt>
		</div>
		<div v-if="type == 'chatgpt_train'">
			<chatgpt_train :library="true" ref="element"></chatgpt_train>
		</div>
		<div v-if="type == 'config'">
			<config :library="true" ref="element"></config>
		</div>
		<div v-if="type == 'config_characteristic'">
			<config_characteristic :library="true" ref="element"></config_characteristic>
		</div>
		<div v-if="type == 'characteristics'">
			<characteristics :library="true" ref="element" :name="name" :version="version"></characteristics>
		</div>
		<div v-if="type == 'machine_learning'">
			<machine_learning :library="true" ref="element" :name="name" :version="version"></machine_learning>
		</div>
	</div>
</template>

<script>
	import store from "../store";
	import uniqueId from "lodash.uniqueid";
	import template from "lodash.template";
	import utils from "../services/utils.js";
    import docx from '../components/docx.vue';
	import chatgpt from '../views/Chatgpt.vue';
	import library from "../services/library.js";
    import config from '../components/config.vue';
	import chatgpt_train from '../views/ChatgptTrain.vue'
	import rules_editor from '../components/rules_editor.vue'
	import characteristics from '../views/Characteristics.vue'
	import machine_learning from '../views/MachineLearning.vue'
    import database_requests from '../views/DatabaseRequest.vue'
    import dashboard_builder from '../views/DashboardBuilder.vue'
    import validation_builder from '../views/ValidationBuilder.vue'
    import config_characteristic from '../components/config_characteristic.vue';
    import document_extraction_zones from '../components/document_extraction_zones.vue'

	export default {
		name: "library",
		components: {
			document_extraction_zones,
			config_characteristic,
			database_requests,
			dashboard_builder,
			validation_builder,
			machine_learning,
			characteristics,
			chatgpt_train,
			rules_editor,
			chatgpt,
			config,
			docx
		},
		data() {
			return {
				// Mode "test en place" du générateur de code dans le tableau de bord
				// (TODO_CODEGEN_CHAT.md section 10) : désactive les boutons
				// d'enregistrement tant qu'un bloc teste un code généré.
				codegenFocusMode: false,

				types: [
					{ value: "document_zone", text: "document_zone" },
					{ value: "dashboard", text: "Tableau de bord" },
					{ value: "validation", text: "Validation" },
					{ value: "db", text: "Requêtes DB" },
					{ value: "docx", text: "Docx" },
					{ value: "rules", text: "Règles" },
					{ value: "chatgpt", text: "ChatGPT" },
					{ value: "chatgpt_train", text: "ChatGPT modèles" },
					{ value: "machine_learning", text: "Machine learning" },
					{ value: "config", text: "Configuration" },
					{ value: "config_characteristic", text: "Configuration des caractéristiques" },
					{ value: "characteristics", text: "Recherche de caractéristiques" }
				],
				names: [],
				versions: [],
				type: "",
				name: "",
				new_name: name,
				version: "",
				id: uniqueId(),
				load_name: "",
				load_version: "",
				search_lists_input: "",
				search_lists_result: [],
				search_lists_result_libelle: [],
				variant_show: false,
				column: "",
				name: "",
				tabulator_data: [],
				lists: {},
				search: "",
				create: true,
				env: false,
				user: {},
			};
		},
		props: {
			_title: {
				default: null
			},
			_type: {
				default: null
			},
			minimal: {
				default: false
			},
			prev_data: {
				default: () => []
			},
			hide_treatment: {
				default: false
			}
		},
		computed: {
			names_filters() {
				if (!this.search) return this.names;
				else
					return this.names.filter((item) =>
						item
							? item
									.toLowerCase()
									.indexOf(this.search.toLowerCase()) != -1
							: 0
					);
			},
		},
		watch: {
			type: {
				async handler() {
					this.set_name();
				},
			},
			load_name: {
				async handler() {
					var elements = await library.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
		},
		methods: {

			onCodegenTestMode(active) {
				this.codegenFocusMode = !!active;
			},

			get_data: function () {
				return this.$refs.element.get_data();
			},
			get_data_blob: async function () {
				return await this.$refs.element.get_data_blob();
			},
			get_data_files: async function (all_files = true) {
				return await this.$refs.element.get_data_files();

			},
			async rename() {
				await library.rename(this.type, this.name, this.new_name);
				this.name = this.new_name;
				await this.set_name();
			},
			async archive_confirm() {
				const ok = await this.$bvModal.msgBoxConfirm(
					`Archiver "${this.name}" (toutes les versions seront désactivées) ?`,
					{ title: 'Archiver', okVariant: 'warning', okTitle: 'Archiver', cancelTitle: 'Annuler' }
				);
				if (!ok) return;
				await library.archive(this.name, this.type);
				this.name = '';
				this.version = '';
				await this.set_name();
				this.$notify({ group: 'info', title: 'Élément archivé', type: 'success' });
			},
			async new_elem() {
				this.name = "";
				this.version = "";
				this.$refs.element.new();
			},
			async set_name() {
				var names = await library.getby_production(this.type, null, false, false, false);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].name);
				}
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return async function (e) {
						var data = JSON.parse(e.target.result);
						document.body.style.cursor = "wait";
						await self.$refs.element.load(data);
						document.body.style.cursor = "default";
					};
				})(file);

				reader.readAsText(file);
			},
			async load_db() {
				document.body.style.cursor = "wait";
				var result = await library.load(
					this.load_name,
					this.load_version,
					this.type
				);
				this.name = this.load_name;
				this.version = this.load_version;
				await this.$refs.element.load(result);
				this.env = false;
				//console.log(result);
				if (result.env && result.env == this.user.env) 
					this.env = true;
				document.body.style.cursor = "default";
			},
			async save() {
				var data = await this.$refs.element.save();

				utils.saveToFile(
					JSON.stringify(data),
					(this.name ? this.name : this.type) + ".json"
				);
			},
			async save_db() {
				var data = await this.$refs.element.save(false);
				if (this.env) 
					data.env = this.user.env;

				console.log(data.data_db)

				await library.save(
					this.name,
					this.version,
					data,
					this.type,
					this.env,
					data.data_db === undefined ? {} : data.data_db,
					(this.type == 'rules' || 
						this.type == 'config_characteristic' || 
						this.type == 'characteristics' || 
						this.type == 'validation' || 
						this.type == "machine_learning" || 
						this.type == "code" || 
						this.type == "chatgpt_train" || 
						this.type == "dashboard")
					? true : false
				);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement en base effectué",
					type: "success",
				});
			},
			updateList(id, name, list, parameters) {
				if (name) this.name = name;

				if (list.length == 0) this.create = true;
				else this.create = false;
			},
			update_data(id, data) {
				this.tabulator_data = data;
			},
		},
		mounted: async function () {
			this.user = store.state.user;
			if (store.state.user.rules && !store.state.user.rules.library && this._type != "db") {
				this.$router.push({ name: "profile" });
			}

			if (this._type)
				this.type = this._type;
			else
				this.type = "document_zone";
		},
	};
</script>

<style scoped>
/* Mode "test en place" du générateur de code dans le tableau de bord
   (TODO_CODEGEN_CHAT.md section 10) : verrouille toute la barre d'actions de la
   bibliothèque (Type/Nom/Version/Charger/Enregistrer/Fichier/Renommer/Archiver/
   Nouveau) tant qu'un bloc teste un code généré. */
.library-locked-by-test {
	pointer-events: none;
	opacity: 0.5;
	filter: grayscale(60%);
}
</style>
